import { Button } from '@/components/ui/button';

interface PagerProps {
  page: number;
  totalPages: number;
  total: number;
  onPage: (page: number) => void;
}

export function Pager({ page, totalPages, total, onPage }: PagerProps) {
  return (
    <div className="flex items-center justify-between pt-4 text-sm text-muted-foreground">
      <span>{total} entries</span>
      <div className="flex items-center gap-2">
        <Button size="sm" variant="outline" disabled={page <= 1} onClick={() => onPage(page - 1)}>
          Previous
        </Button>
        <span>
          Page {totalPages === 0 ? 0 : page} of {totalPages}
        </span>
        <Button size="sm" variant="outline" disabled={page >= totalPages} onClick={() => onPage(page + 1)}>
          Next
        </Button>
      </div>
    </div>
  );
}
